import type { CompositionComponent, Material } from '../../gql';

import {
    randBoolean,
    randNumber,
    randProductMaterial,
    randUuid,
    randWord,
} from '@ngneat/falso';
import { startCase } from 'lodash';

import { ComponentType } from '../../gql';
import { mockManufactureDetail } from '../mockManufactureDetail';

import { mockMaterialSubcategory } from './mockMaterialSubcategory';

const mockMaterial = (override?: Partial<Material>): Material => ({
    materialNumber: randUuid(),
    state: randWord(),
    materialPublicId: randUuid(),
    materialVersion: randNumber(),
    materialSubcategory: mockMaterialSubcategory(),
    libraryRef: startCase(`${randProductMaterial()} material`), // Same as brandMaterialRef from old schema
    weight: `${randNumber({ min: 1, max: 200 })} kg/cm2`, // Example: 1 kg/cm2
    designAttribute: randBoolean() ? randProductMaterial() : undefined,
    isDeleted: randBoolean(),
    manufactureDetail: mockManufactureDetail(),
    materialSizes: [],
    colourGroupPublicIds: Array.from(
        { length: randNumber({ min: 1, max: 3 }) },
        () => randNumber()
    ),
    // For zippers: Teeth first, then tape, then slider. For other materials: STANDARD
    materialComposition: randBoolean()
        ? mockZipperComposition()
        : mockStandardComposition(),
    ...override,
    ['__typename']: 'Material',
});

// Below is temporary, can be deleted after backend

const mockCompositionComponent = (
    overwrite?: Partial<CompositionComponent>
): CompositionComponent => ({
    type: ComponentType.Standard,
    composition: `${randNumber({ min: 1, max: 100 })}% ${randProductMaterial()}`,
    ['__typename']: 'CompositionComponent',
    ...overwrite,
});

// Helper to generate a complete zipper composition (Teeth, Tape, Slider in correct order)
const mockZipperComposition = (): Array<CompositionComponent> => [
    mockCompositionComponent({ type: ComponentType.ZipperTeeth }),
    mockCompositionComponent({ type: ComponentType.ZipperTape }),
    mockCompositionComponent({ type: ComponentType.ZipperSlider }),
];

// Helper to generate standard material composition
const mockStandardComposition = (): Array<CompositionComponent> => [
    mockCompositionComponent({ type: ComponentType.Standard }),
];

export {
    mockMaterial,
    mockZipperComposition,
    mockStandardComposition,
    mockCompositionComponent,
};
